// Design tokens for the CrowdVox dashboards.
//
// One import site for colour, type and elevation so a third dashboard does
// not become a third fork. The palette itself still lives in
// VitalCityDashboard/brandPalette.js, which several legacy pages import
// directly; this module re-exports it and adds the tokens the 2026 Figma
// (file hYHM1jX4YwTQ42r5T82zK2) introduces on top.
import { PRIMARY, PRIMARY_MUTED, BRAND } from "../pages/VitalCityDashboard/brandPalette";

export * from "../pages/VitalCityDashboard/brandPalette";

// brandPalette keeps these inside BRAND; surfaces want them flat.
export const INK = BRAND.INK;
export const SUBTLE = BRAND.SUBTLE;
export const BORDER = BRAND.BORDER;

export const FONT = "'Montserrat', sans-serif";

// Neutrals. The Figma runs a warmer ink than the legacy INK (#1F2430) on
// panel titles and stat values, so both exist rather than one overriding
// the other: FIG_INK for surfaces built to the new frames, INK elsewhere.
export const FIG_INK = "#2C2926";
export const FIG_MUTED = "#6D6A67";
export const PANEL_BORDER = "rgba(109, 106, 103, 0.1)";
export const CARD_BORDER = "rgba(109, 106, 103, 0.16)";
export const HAIRLINE = "#EDEEF3";
export const TRACK = "#EEF0F8";

// Elevation, straight from the Figma effect styles.
export const SHADOW_CARD = "0px 5px 60px 0px rgba(84, 90, 129, 0.15)";
export const SHADOW_PANEL =
  "0px 6px 29px 0px rgba(89, 108, 148, 0.07), 0px 0.751px 3.631px 0px rgba(89, 108, 148, 0.04)";
export const SHADOW_CTA =
  "0px 6px 14.5px rgba(89, 108, 148, 0.07), 0px 0.751px 1.816px rgba(89, 108, 148, 0.04)";

export const RADIUS_PANEL = 20;
export const RADIUS_CTA = 10;

// The CTA / active-tab gradient and the bar fill share one ramp.
export const CTA_GRADIENT = `linear-gradient(100deg, ${PRIMARY} 10%, ${PRIMARY_MUTED} 130%)`;
export const BAR_GRADIENT = `linear-gradient(90deg, ${PRIMARY} 0%, ${PRIMARY_MUTED} 100%)`;

// Categorical series for this dashboard. brandPalette.CATEGORICAL still
// leads with legacy purple (#3D2969), which reads off-brand against the
// 2026 blue primary, so surfaces built to the new frames use this instead.
// Values are taken from the Figma's own theme-family and legend colours.
export const SERIES = [
  PRIMARY,      // #2E45DA primary blue
  "#0E8A45",    // green
  "#B7791F",    // gold
  "#752FD8",    // violet
  /* Olive, NOT magenta #C42F61: pink and pink shades never appear in the
     portal (standing rule, 2026-08-17). Olive is the brandPalette family's
     own non-pink slot and stays distinct from the gold at legend size. */
  "#8C9F4B",    // olive
  "#0E8FB0",    // teal
  "#B02E0E",    // rust
  "#78828F",    // slate
  /* Extended so colors NEVER repeat within one chart (user 2026-08-21):
     the longest ranked lists the pipeline emits are 10-12 rows, and a
     cycling palette was putting the same hue on two different rows.
     All four stay outside the banned pink family. */
  "#7A4A21",    // brown
  "#6D5F8E",    // muted plum
  "#145A32",    // forest
  "#2C3E66",    // navy slate
];

// Neutral fills for answers that carry no position.
export const NEUTRAL = "#78828F";
export const UNRESOLVED = "#E3E8F0";
